var React = require('react');

function VoEiendom48px (props) {
    return React.createElement("symbol",props,React.createElement("path",{"d":"M47.461 27.649a.988.988 0 0 1-1.404-.086l-2.241-2.54v20.844c0 1.1-.893 1.997-1.991 1.997H5.99a1.998 1.998 0 0 1-1.991-1.997V25.023l-2.24 2.54a.992.992 0 0 1-1.405.086.998.998 0 0 1-.086-1.408l3.997-4.531c.016-.017.029-.036.046-.052L23.162.289c.377-.429 1.114-.429 1.491 0l18.852 21.369c.017.016.03.034.046.052l3.997 4.531a.998.998 0 0 1-.087 1.408zm-5.636-4.883L23.908 2.455 5.99 22.766v23.101h35.835V22.766zm-22.894.143a5.983 5.983 0 0 1 4.977 2.661 5.98 5.98 0 0 1 4.977-2.661c3.293 0 5.972 2.658 5.972 5.923 0 1.533-.703 3.145-1.88 4.313l-8.409 7.48c-.053.047-.116.071-.175.105-.038.022-.072.051-.112.068a.99.99 0 0 1-.373.078.985.985 0 0 1-.373-.078c-.041-.017-.074-.046-.113-.068-.059-.034-.121-.058-.174-.105l-8.37-7.443c-1.217-1.205-1.92-2.817-1.92-4.35 0-3.265 2.679-5.923 5.973-5.923zm-2.693 8.817l7.67 6.818 7.709-6.855c.756-.752 1.249-1.86 1.249-2.857 0-2.166-1.785-3.926-3.981-3.926-2.196 0-3.982 1.76-3.982 3.926a.996.996 0 1 1-1.991 0c0-2.166-1.785-3.926-3.981-3.926-2.196 0-3.982 1.76-3.982 3.926 0 .997.494 2.105 1.289 2.894z"}));
}

VoEiendom48px.displayName = "VoEiendom48px";

VoEiendom48px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 47.82 47.9"};

module.exports = VoEiendom48px;

VoEiendom48px.default = VoEiendom48px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/48px/vo-eiendom-48px.svg
// module id = 1174
// module chunks = 0